import { getPreviousSortedHeader } from './dom';
import { ASC_CLASSNAME, DESC_CLASSNAME } from '../constants';

export function getSortingOrder(tableHeader) {
  return tableHeader.classList.contains(ASC_CLASSNAME) === false ? 'ASCENDING' : 'DESCENDING';
}

export function toggleTableHeaderSorter(table, currentTableHeader, order = 'ASCENDING') {
  if (!currentTableHeader || !table) return;

  const previousSortedHeader = getPreviousSortedHeader(table);

  if (previousSortedHeader && previousSortedHeader !== currentTableHeader) {
    previousSortedHeader.classList.remove(ASC_CLASSNAME);
    previousSortedHeader.classList.remove(DESC_CLASSNAME);
  }

  if (order === 'ASCENDING') {
    currentTableHeader.classList.remove(DESC_CLASSNAME);
    currentTableHeader.classList.add(ASC_CLASSNAME);
  } else {
    currentTableHeader.classList.remove(ASC_CLASSNAME);
    currentTableHeader.classList.add(DESC_CLASSNAME);
  }
}
